<div class="hello-band py-4">
	<div class="container">
		<div class="row">
			 <div class="col-12 pt-1">
				<h1>Een wachtwoord aanvragen?</h1>
			</div>
		</div>
	</div>
</div>
<div class="container py-5">

	<section *ngIf="currentUser != false">
		<div class="container">
			<p>Je bent al ingelogd hoor!</p>
		</div>
	</section>
	<section *ngIf="currentUser == false">

		<div class="alert alert-success" *ngIf="successmessage">Er is een e-mail naar <em>{{email}}</em> onderweg met een link om je wachtwoord opnieuw in te stellen.</div>

		<div *ngIf="!successmessage">

			<p class="lead">Geen probleem! Vul hieronder je e-mailadres in en dan sturen wij een e-mail met een link om je wachtwoord in te stellen.</p>

			<div class="form-group">
				<label for="email">Je e-mailadres</label>
				<input type="text" id="email" class="form-control" [(ngModel)]="email" value="{{email}}" [ngClass]="{ 'is-invalid': submitted && errors.email }" />
				<div *ngIf="submitted && errors.email" class="invalid-feedback">
			      <div *ngIf="errors.email.required">Er is geen e-mailadres ingevuld.</div>
			      <div *ngIf="email.errors.email">Dit lijkt geen echt e-mailadres te zijn, kijk eens goed.</div>
				</div>

				<div *ngIf="errors2.email" class="invalid-feedback" style="display:block;">{{errors2.email}}</div>
			</div>

			<button (click)="save()" class="btn btn-success">
				<span>Nieuw wachtwoord aanvragen</span>
			</button>

		</div>

		<p class="text-dark mt-5 ">Mocht dat nou niet lukken, vraag dan aan je docent of hij een nieuw wachtwoord voor je invult. Kom je er dan nog steeds niet uit? <a href="https://uitgeverijneo.nl/contact">Neem dan contact met ons op.</a></p>
	</section>

</div>
